module.exports = ".mat-column-remarks {\n  -webkit-box-flex: 2;\n      -ms-flex: 2;\n          flex: 2; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/components/request-feedback-list/request-feedback-list.component.scss
// module id = ./src/app/shared/components/request-feedback-list/request-feedback-list.component.scss
// module chunks = main